import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TicketStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/core/src/enums/ticket-status.enum';

import { TicketSection } from './ticket-section.component';

interface TicketTabTodoProps {
  onActionRead: (id: string) => void;
}

export const TicketTabTodo = ({
  onActionRead,
}: TicketTabTodoProps): React.JSX.Element => {
  return (
    <Stack direction="column" gap={GapEnum.XL}>
      <TicketSection status={TicketStatus.New} onActionRead={onActionRead} />
      <TicketSection
        status={TicketStatus.InProgress}
        onActionRead={onActionRead}
      />
    </Stack>
  );
};
